var _linearGradient, _linearGradient2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWechat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 634,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354.401 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50.056%",
    x2: "50.056%",
    y1: "94.15%",
    y2: ".437%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05cd66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61f380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9eee69"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50.089%",
    x2: "50.089%",
    y1: "93.535%",
    y2: "-.036%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.586 33.597c10.72 0 13.31 7.267 13.31 14.245v13.02c0 3.023.144 5.973.503 8.347h-5.683l-.575-4.39h-.216c-1.871 2.735-5.684 5.18-10.648 5.18-7.05 0-10.647-4.963-10.647-10 0-8.416 7.482-13.02 20.935-12.95v-.718c0-2.878-.792-8.13-7.914-8.058-3.31 0-6.691.936-9.136 2.59l-1.203-4.39c2.682-1.691 6.886-2.876 11.274-2.876zm-111.588 0c11.368 0 14.317 10 14.317 16.403 0 1.295-.072 2.23-.216 2.95h-24.388c.143 8.488 5.54 12.014 11.87 12.014 4.533 0 7.338-.792 9.64-1.799l1.151 4.532c-2.23 1.008-6.114 2.231-11.654 2.231-10.648 0-17.122-7.122-17.122-17.554 0-10.504 6.258-18.777 16.402-18.777zM250.204 20c5.971 0 9.672 1.226 11.327 2.017l-1.399 5.249c-2.303-1.151-5.684-2.014-9.713-2.014-11.367 0-18.92 7.266-18.92 19.928 0 11.87 6.835 19.424 18.56 19.424 3.886 0 7.77-.791 10.29-2.014l1.356 4.972c-2.23 1.15-7.04 2.366-12.94 2.366-13.668 0-23.884-8.633-23.884-24.532 0-15.18 10.287-25.396 25.324-25.396zm94.907 7.986v6.403h9.064v4.82h-9.064v18.705c0 4.317 1.223 6.762 4.748 6.762 1.727 0 2.682-.146 3.288-.323l1.254 4.555c-1.178.557-3.75 1.02-6.197 1.02-2.949 0-5.323-1.007-6.834-2.661-1.727-1.943-2.446-5.036-2.446-9.137V39.209h-5.396v-4.82h5.396v-6.403zM136.618 20.72l5.756 24.532c1.44 6.115 2.734 12.086 3.597 16.763h.144c.791-4.821 2.302-10.576 3.957-16.835l6.475-24.46h6.547l5.9 24.604c1.366 5.827 2.661 11.51 3.38 16.618h.144c1.007-5.323 2.374-10.72 3.885-16.762l6.403-24.46h6.403l-13.74 48.489h-6.548l-6.115-25.18c-1.51-6.26-2.518-11.008-3.166-15.9h-.144c-.79 4.892-1.942 9.569-3.74 15.828l-6.907 25.252h-6.547L130 20.719zm137.447.117v19.019h.144c1.007-1.798 2.59-3.453 4.532-4.46 1.87-1.151 4.1-1.8 6.475-1.8 4.676 0 12.159 2.879 12.159 14.893v20.72h-6.331V49.137c0-5.612-2.087-10.288-8.058-10.288-4.101 0-7.266 2.878-8.49 6.33-.36.865-.431 1.8-.431 3.023v21.007h-6.331V20.837zM308.96 59.28c0 4.173 2.734 6.043 5.9 6.043 4.604 0 7.554-2.878 8.56-5.827.217-.648.289-1.367.289-2.015v-6.043c-6.907-.144-14.75 1.079-14.75 7.842zM204.495 38.129c-6.475 0-9.209 5.9-9.712 10.288H213.2c.072-4.029-1.655-10.288-8.705-10.288z",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 33.466c0 10.04 5.474 19.213 13.933 25.286.746.496 1.12 1.24 1.12 2.231 0 .248-.125.62-.125.868-.622 2.479-1.742 6.57-1.866 6.693-.124.372-.249.62-.249.992 0 .744.622 1.363 1.369 1.363.248 0 .497-.124.746-.248l8.832-5.082c.622-.371 1.369-.62 2.115-.62.374 0 .871 0 1.244.125 4.106 1.24 8.584 1.859 13.187 1.859 22.267 0 40.306-14.998 40.306-33.467S62.573 0 40.306 0C18.038 0 0 14.998 0 33.466",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.86 86.628c3.847 0 7.57-.5 10.92-1.498.249-.125.621-.125.993-.125.62 0 1.241.25 1.738.5l7.322 4.245c.248.125.372.25.62.25.62 0 1.117-.5 1.117-1.124 0-.25-.124-.5-.124-.874 0-.125-.993-3.497-1.49-5.62-.123-.25-.123-.5-.123-.749 0-.75.372-1.374.993-1.873 7.073-5.12 11.54-12.738 11.54-21.23 0-15.485-15.015-28.098-33.506-28.098S44.353 42.92 44.353 58.53c0 15.485 15.016 28.098 33.507 28.098z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.05 22.662c0 2.891-2.288 5.18-5.18 5.18s-5.18-2.289-5.18-5.18 2.29-5.18 5.18-5.18 5.18 2.289 5.18 5.18M58.92 22.662c0 2.891-2.288 5.18-5.179 5.18s-5.18-2.289-5.18-5.18 2.289-5.18 5.18-5.18 5.18 2.289 5.18 5.18",
    fill: "#168743"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#919191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.82 49.856c0 2.518 2.015 4.532 4.533 4.532s4.532-2.014 4.532-4.532-2.014-4.532-4.532-4.532-4.533 2.014-4.533 4.532M62.482 49.856c0 2.518 2.014 4.532 4.532 4.532s4.533-2.014 4.533-4.532-2.015-4.532-4.533-4.532-4.532 2.014-4.532 4.532"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWechat);
export default __webpack_public_path__ + "static/media/wechat.8bf47dfdbdb98adc0a84d6719d1d540b.svg";
export { ForwardRef as ReactComponent };